export default __webpack_public_path__ + "static/media/garen-bg-large.a136f428.jpg";